import { Suspense } from "react";
import "./index.css";
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider, HelmetServerState } from 'react-helmet-async';
import { AuthProvider } from "./core/context/AuthContext";
import './App.css';
import { addGtag } from "core/constants/scriptFunc";
import NormalLayout from './layouts/normal';
import { routeItems, RouteItemProp } from "./core/routes";
import { SettingProvider } from "./core/context/SettingContext";
import NotFoundPage from "pages/NotFound/NotFoundPage";
import HashRedirector from "components/HashRedirector/HashRedirector";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import loadingImg from "./assets/images/loading.png";

const queryClient = new QueryClient()
const helmetContext: { helmet?: HelmetServerState; } = {};

export const App = () => {
  const partnerTrackCode = useSelector((state: any) => state.setting.partnerTrackCode);

  return (
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={(
          <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center z-10 bg-[#FFFFFFB3]">
            <img src={loadingImg} alt='loading...' width={200} height={200} />
          </div>
        )}>
          <BrowserRouter>
            <HashRedirector />
            <AuthProvider>
              <SettingProvider>
                <NormalLayout>
                  <>
                    {partnerTrackCode && addGtag(partnerTrackCode[window.location.pathname])}
                    {partnerTrackCode && addGtag(partnerTrackCode['%'])}
                    <Routes>
                    {
                      routeItems.map((item:RouteItemProp, index:number) => {
                        return (
                          <Route path={item.path} element={item.element} key={index}/>
                        )
                      })
                    }
                      {/* Define the Not Found route explicitly */}
                      <Route path="/404" element={<NotFoundPage />} />
                      {/* Catch-all route to redirect to NotFoundPage */}
                      <Route path="*" element={<Navigate to="/404" />} />
                    </Routes>
                  </>
                </NormalLayout>
              </SettingProvider>
            </AuthProvider>
          </BrowserRouter>
        </Suspense>
      </QueryClientProvider>
    </HelmetProvider>
  );
}